import { SwitchAccountWrapper, SwitchAccountTitle } from "../../container/accountSettings.styles";

import { ReactComponent as Line } from "@assets/icon/line.svg";
import Icon from "@components/Icon/Icon";

const SwitchAccount = () => {
    return (
        <SwitchAccountWrapper>
            <SwitchAccountTitle> Swtich Account </SwitchAccountTitle>
            <Icon icon={Line} alt="image" size={10} />
        </SwitchAccountWrapper>
    );
};
export default SwitchAccount;
